// extracted by mini-css-extract-plugin
module.exports = {"stickyFooter":"ProformaGenerationsTable_stickyFooter__3RMa9"};